import React, { MouseEvent, ReactElement } from "react";
import { GrFormClose } from "react-icons/gr";
import { RiArticleLine } from "react-icons/ri";
import classNames from "classnames";
import useRouting, { Link } from "../../../contexts/Routing";
import { TicketMessageArticle, TicketMessageArticleInput } from "../../../__generated__/api";
import { HtmlRenderer } from "../../html-render/HtmlRenderer";
import Styles from "./AnswerFinder.module.scss";
import Avatar from "../../avatar/Avatar";
import { useTheme } from "../../../contexts/Theme";
import Button from "../../theme/button/Button";

export interface TicketMessageArticlePreview extends TicketMessageArticleInput {
    iconUrl?: string | null;
}

export default function ArticlePreview({
    article, onClose, className, isClickable, variant,
}: {
    article: TicketMessageArticlePreview,
    onClose?: () => void;
    isClickable?: boolean;
    className?: string;
    variant?: "picker" | "preview";
}): ReactElement {
    const { Paths } = useRouting();
    const theme = useTheme();

    const content = (
        <>

            {theme.isV3 && (
                <div className={Styles.icon}>
                    {article.iconUrl ? (
                        <Avatar src={article.iconUrl as string} className="" variant="xs" />
                    ) : (
                        <RiArticleLine />
                    )}
                </div>
            )}

            <div className={Styles.content}>
                <strong className={Styles["item-title"]}>
                    {article.title}
                </strong>
                {theme.isV3 && (
                    <HtmlRenderer
                        stripFormatting={variant === "picker" ? "limitted" : "all"}
                        className={Styles.preview}
                        html={article.previewText ?? ""}
                    />
                )}

            </div>

        </>
    );
    return (
        <div
            className={theme.isV3
                ? classNames(Styles["article-preview-container"], Styles[`article-preview-${variant}`])
                : classNames(variant === "preview" ? `border border-1 rounded p-2` : "p-2", className)}
        >
            <div className={theme.isV3
                ? classNames(isClickable ? "" : Styles["article-preview"])
                : "d-flex justify-content-between align-items-center"}
            >
                {isClickable ? (
                    <Link
                        to={Paths.ANSWERS_GET}
                        params={{ id: article.id }}
                        target="_blank"
                        rel="noreferrer"
                        className={theme.isV3 ? Styles["article-preview"] : "text-decoration-none text-secondary"}
                    >
                        {content}
                    </Link>
                ) : content}

                {onClose && (
                    <Button
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            onClose();
                        }}
                        variant="none"
                        size="small"
                        className={Styles["close-button"]}
                        aria-label="Remove article"
                        isClose={theme.isV3}
                        prefixIcon={!theme.isV3 ? <GrFormClose /> : undefined}
                    />
                )}

            </div>
            {!theme.isV3 && (
                <small>
                    <HtmlRenderer html={article.previewText ?? ""} />
                </small>
            )}

        </div>
    );
}
ArticlePreview.defaultProps = {
    className: "",
    onClose: undefined,
    isClickable: false,
    variant: "picker",
};
